import iconBag from '../assets/icon-bag.svg';
import iconPreInscricao from '../assets/icon-pre-inscricao.svg';
import iconMegafone from '../assets/icon-mega-fone.png';
import iconArrowDown from '../assets/icon-arrow-down.png';

import {
	ButtonDefault,
	CollapseContent,
	Description,
	ExtraContent,
	PurchaseCardContainer,
	Title,
	TagDiscount,
	TextGradient,
	TagTopGradient,
	BorderGradientWrapper,
} from './PurchaseCard-2025-1.style';
import { useState } from 'react';
import { Collapse, Grid, Typography } from '@mui/material';

export default function PurchaseCard20251({
	turma,
	type,
	available,
	originalPrice,
	qtdParcelas,
	valorParcela,
	valorAVista,
	description,
	subtitle,
}) {
	const [isHidden, setIsHidden] = useState(true);

	return (
		<Grid
			container
			flexDirection="column"
			alignItems="center"
			justifyContent="space-between"
			gap={2}
		>
			<PurchaseCardContainer
				style={{ backgroundColor: available ? '#0D0D0D' : '#333333', paddingTop: available ? '0px' : '24px' }}
			>
				{available && (
					<BorderGradientWrapper>
						<TagTopGradient>
							<TextGradient
								style={{
									fontWeight: 700,
									lineHeight: '32px',
									fontSize: '32px',
									textTransform: 'uppercase',
									fontFamily: 'Bebas Neue',
								}}
								className={'gradient-text'}
							>
								Oportunidade única!*
							</TextGradient>
							<p style={{ lineHeight: '16px', fontSize: '18px' }}>Aluno Hardwork não para de estudar!</p>
						</TagTopGradient>
					</BorderGradientWrapper>
				)}
				<div style={{ paddingTop: '24px' }}>
					<Title style={{ fontSize: 32, lineHeight: '32px', fontWeight: 400, color: '#C9C9C9' }}>
						Arena Hardwork
					</Title>
					<TextGradient
						style={{ fontSize: 54, lineHeight: '54px', fontWeight: 800 }}
						className={'gradient-text'}
					>
						{type}
					</TextGradient>
					{/*<Title style={{ color: '#E6E6E6' }}>{subtitle}</Title>*/}
				</div>
				<div>
					<Description>{description}</Description>
				</div>
				<div>
					<Title>
						de{' '}
						<span style={{ textDecoration: 'line-through' }}>
							{originalPrice?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
						</span>
					</Title>
					<Title style={{ fontSize: 20 }}>
						por até <span style={{ color: 'white', fontWeight: 700 }}>{qtdParcelas}x</span> de
					</Title>
					<TextGradient
						style={{ fontFamily: 'Outfit', fontSize: 56, fontWeight: 700, lineHeight: '56px' }}
						className={'gradient-text'}
					>
						{valorParcela?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
					</TextGradient>
					<Title style={{ fontSize: 20 }}>
						ou{' '}
						<span style={{ color: 'white', fontWeight: 700 }}>
							{valorAVista?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
						</span>{' '}
						à vista
						{/* <TagDiscount style={{ backgroundColor: '#00AD5880' }}>5% OFF</TagDiscount> */}
					</Title>
				</div>
				<div style={{ width: '100%' }}>
					<ButtonDefault
						onClick={() => window.open(`https://hardworkmedicina.com.br/inscricao/${turma}`)}
						style={{ backgroundColor: '#00AD58' }}
					>
						{available ? (
							<>
								<img
									src={iconBag}
									alt={'Ícone de carrinho de compras'}
								/>
								Inscrever-se no Online
							</>
						) : (
							<>
								<img
									src={iconPreInscricao}
									alt={'Ícone de pré-inscrição'}
								/>
								Faça sua pré-inscrição
							</>
						)}
					</ButtonDefault>
				</div>
			</PurchaseCardContainer>
			{available && (
				<ExtraContent onClick={() => setIsHidden(!isHidden)}>
					<CollapseContent style={{ fontFamily: 'Poppins' }}>
						<div style={{ display: 'flex', gap: '8px' }}>
							<img
								src={iconMegafone}
								alt={'Ícone de megafone'}
								width={16}
								height={16}
							/>
							<Title
								style={{
									textTransform: 'uppercase',
									fontWeight: 700,
									fontSize: 16,
									textAlign: 'center',
									lineHeight: '16px',
									padding: 0,
									color: '#FFFFFF',
								}}
							>
								*E se eu não passar para a segunda fase?
							</Title>
						</div>
						<img
							src={iconArrowDown}
							alt={'Ícone de seta para baixo'}
							width={16}
							height={16}
							style={{ transform: isHidden ? 'rotate(0deg)' : 'rotate(180deg)' }}
						/>
					</CollapseContent>
					<Collapse in={!isHidden}>
						<div style={{ paddingTop: '12px' }}>
							<Title style={{ color: '#B3B3B3' }}>
								Exclusivamente para quem se inscrever até às 23:59 do <strong>dia 28/03</strong>, caso
								não passe para a segunda fase, tu poderás escolher entre: <br />
								<br />• Usar o valor investido para migrar para o <strong>Trilha Revalida 25.2</strong>;
								<br />• Continuar na rotina de estudos do Arena;
							</Title>
						</div>
					</Collapse>
				</ExtraContent>
			)}
			<Grid>
				<Typography
					fontFamily={'Manrope'}
					color={'#191919'}
					fontSize={14}
				>
					¹ A liberação dos casos temáticos acontece de forma progressiva.
				</Typography>
			</Grid>
		</Grid>
	);
}
